import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import CitizenForm from './CitizenForm.vue'
import { CardHeader } from '../../../../components'
import {
  AddCitizenOpts,
  AddressSuggesterService,
  AppAuthService,
  CitizensService,
  MunicipalEntitiesService,
} from '@prodcard/core'
import { pickBy } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizensNewPage',
  props: {
    addressSuggesterService: {},
    citizensService: {},
    municipalEntitiesService: {},
    authService: {},
    redirectToBack: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()
const loading = ref(false)

const createCitizen = (citizen: AddCitizenOpts) => {
  handleError(async () => {
    const opts: AddCitizenOpts = {
      ...(pickBy(citizen, v => v) as AddCitizenOpts),
    }

    const id = await props.citizensService.add(createCtx(), opts)
    callSuccessToast('Гражданин создан')
    if (props.redirectToBack) {
      router?.back()
    } else {
      await router?.replace({ path: `/citizens/${id}/edit` })
    }
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            title: _withCtx(() => [
              _createTextVNode(" Новый гражданин ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(CitizenForm, {
            "address-suggester-service": _ctx.addressSuggesterService,
            "auth-service": _ctx.authService,
            "municipal-entities-service": _ctx.municipalEntitiesService,
            loading: loading.value,
            onOnSubmit: createCitizen,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router?.back()))
          }, null, 8, ["address-suggester-service", "auth-service", "municipal-entities-service", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})